export default __webpack_public_path__ + "static/media/articleImg.7cf5bfce.jpg";